import React, {Component} from 'react';


export class LinkToSection extends Component {
    getUrl() {
        return this.props.url;
    }

    renderText() {
        return this.props.text;
    }

    render() {
        return <span className="ml-2 mr-2 link_to_section"><a href={this.getUrl()}>[{this.renderText()}]</a></span>
    }

    prefix() {
        if (this.props.prefix === undefined) {
            return 'fas'
        } else {
            return this.props.prefix
        }
    }
}
